import { MenuRootItem, MenuSubItem } from './types';

export interface SipMenuData extends MenuRootItem {
  pilet: string;
}

export class SipMenuStorage {
  private menus: Record<string, SipMenuData> = {};

  public getMenu(route: string): SipMenuData | undefined {
    return this.menus[route];
  }

  public setMenu(route: string, data: SipMenuData): void {
    this.menus = { ...this.menus, [route]: data };
  }

  public removeMenu(route: string): void {
    const { [route]: _, ...rest } = this.menus;
    this.menus = rest;
  }

  public getAllMenus(): SipMenuData[] {
    return Object.values(this.menus);
  }

  public getMenusByPilet(piletName: string): SipMenuData[] {
    return Object.values(this.menus).filter(menu => menu.pilet === piletName);
  }

  public getAllMenuItems(): MenuSubItem[] {
    const items: MenuSubItem[] = [];
    for (const menu of Object.values(this.menus)) {
      items.push({
        title: menu.title,
        route: menu.route,
        icon: menu.icon,
        badge: menu.badge,
        tooltip: menu.tooltip,
      });
      if (menu.subItems) {
        items.push(...menu.subItems);
      }
    }
    return items;
  }
}
